import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $body: document.body,
      $html: document.documentElement,
      $searchTrigger: this.el.querySelector('.search-trigger'),
      $searchCloseTriger: this.el.querySelector('.search-close'),
      $searchContainer: this.el.querySelector('.search-box'),
      $mobileNavTrigger: this.el.querySelector('.mobile-nav-trigger'),
      $mobileCloseTrigger: this.el.querySelector('.mobile-close'),
      $mobilePrimaryNavItems: this.el.querySelectorAll('.sub-trigger'),
      $mobileSubNavItems: this.el.querySelectorAll('nav > ul > li .sub'),
      $mobileSubNavCloseTriggers: this.el.querySelectorAll(
        '.sub .mobile-heading .mobile-close'
      ),
      $mobileBack: this.el.querySelectorAll('.mobile-back'),
      $searchBoxFromContainers: this.el.querySelectorAll('.search-box-form > div'),
      $searchBoxFromButtons: this.el.querySelectorAll('.search-box-form-options .btn'),
      $selectBtnOptionsTriggerBtn: this.el.querySelector('.select-box-options-trigger'),
      $lengthFrom: this.el.querySelector('#BoatSearchLengthFrom'),
      $lengthTo: this.el.querySelector('#BoatSearchLengthTo'),
      $navMainLevel: this.el.querySelectorAll('nav > ul > li'),
      $subDwnOptions: this.el.querySelectorAll('nav > ul > li .link-content ul li'),
      $alertBanner: this.el.querySelector('.alert-banner-container'),
      $alertBannerClose: this.el.querySelector('.alert-banner-close-button')
    };

    console.log('New Hash Scripts')
  }

  addListeners() {
    this.dom.$searchTrigger.addEventListener(
      'click',
      this.toggleSearch.bind(this)
    );
    this.dom.$searchCloseTriger.addEventListener(
      'click',
      this.toggleSearch.bind(this)
    );
    this.dom.$mobileNavTrigger.addEventListener(
      'click',
      this.togglemobileNavMenu.bind(this)
    );
    this.dom.$mobileCloseTrigger.addEventListener(
      'click',
      this.togglemobileNavMenu.bind(this)
    );
    this.dom.$mobilePrimaryNavItems.forEach(item => {
      item.addEventListener('click', this.togleSubMenu.bind(this));
    });
    this.dom.$mobileSubNavItems.forEach(item => {
      item.addEventListener('click', this.bubNavClicked.bind(this));
    });
    this.dom.$mobileBack.forEach(item => {
      item.addEventListener('click', this.closeSubMenu.bind(this));
    });
    this.dom.$mobileSubNavCloseTriggers.forEach(item => {
      item.addEventListener('click', this.closeFromSubMenu.bind(this));
    });
    this.dom.$searchBoxFromButtons.forEach(item => {
      item.addEventListener('click', this.toggleSearchBoxForm.bind(this));
    });
    this.dom.$selectBtnOptionsTriggerBtn.addEventListener('click', this.toggleSelectBtnOptions.bind(this));

    this.dom.$lengthFrom.addEventListener('change', this.handleLenghtFromChange.bind(this));
    this.dom.$lengthTo.addEventListener('change', this.handleLenghtToChange.bind(this));

    this.dom.$navMainLevel.forEach(item => {
      item.addEventListener('keydown', this.handleNavMainLevelKeyDown.bind(this));
    });

    this.dom.$subDwnOptions.forEach(item => {
      item.addEventListener('keydown', this.handleSubDwnOptionsKeyDown.bind(this));
    });
    document.addEventListener('click', this.closeLenghtDropDown.bind(this));

    if (this.dom.$alertBanner) {
      this.dom.$alertBannerClose.addEventListener('click', this.handleHeaderMessage.bind(this));
    }
  }

  toggleSearch() {
    this.dom.$searchContainer.classList.toggle('active');
    this.dom.$html.classList.toggle('mask-overlay search-box-opened');
  }

  togglemobileNavMenu() {
    this.dom.$body.classList.toggle('mask-overlay');
    this.dom.$body.classList.toggle('navigation-opened');
  }

  togleSubMenu(e) {
    e.currentTarget.closest('li').classList.toggle('active');
  }

  closeSubMenu(e) {
    e.currentTarget.closest('.active').classList.remove('active');
  }

  closeFromSubMenu(e) {
    e.currentTarget.closest('.active').classList.remove('active');
    this.togglemobileNavMenu();
  }

  bubNavClicked(e) {
    e.stopPropagation();
  }

  toggleSearchBoxForm(e) {
    this.dom.$searchBoxFromButtons.forEach((item, index) => {
      if (item === e.currentTarget) {
        item.classList.add('active');
        this.dom.$searchBoxFromContainers[index].classList.add('active');
      } else {
        item.classList.remove('active');
        this.dom.$searchBoxFromContainers[index].classList.remove('active');
      }
    });
  }

  toggleSelectBtnOptions(e) {
    e.currentTarget.closest('.select-box').classList.toggle('active');
  }

  handleLenghtFromChange(e) {
    const val = Number(e.currentTarget.value);
    this.dom.$lengthTo.querySelectorAll('option').forEach((option) => {
      const optValue = Number(option.getAttribute('value'));
      if (optValue < val) {
        option.setAttribute('hidden', true);
      } else {
        option.removeAttribute('hidden');
      }
    });
    this.setLenghtValue();
  }

  handleLenghtToChange(e) {
    const val = Number(e.currentTarget.value);
    e.currentTarget.closest('.select-box').classList.remove('active');
    this.dom.$lengthFrom.querySelectorAll('option').forEach((option) => {
      const optValue = Number(option.getAttribute('value'));
      if (optValue > val) {
        option.setAttribute('hidden', true);
      } else {
        option.removeAttribute('hidden');
      }
    });
    this.setLenghtValue();
  }

  closeLenghtDropDown(e) {
    if (e.target.closest('[rel=hbs-length]') === null) {
      this.dom.$selectBtnOptionsTriggerBtn.closest('.select-box').classList.remove('active');
    }
  }

  setLenghtValue() {
    const fromVal = this.dom.$lengthFrom.value;
    const toVal = this.dom.$lengthTo.value;

    if (fromVal === '' && toVal === '') {
      this.dom.$selectBtnOptionsTriggerBtn.innerHTML = this.dom.$selectBtnOptionsTriggerBtn.getAttribute('data-default');
    } else {
      this.dom.$selectBtnOptionsTriggerBtn.innerHTML = `${fromVal}${fromVal !== '' ? '\'' : ''} ${fromVal !== '' && toVal !== '' ? '-' : ''} ${toVal}${toVal !== '' ? '\'' : ''}`;
    }
  }

  handleNavMainLevelKeyDown(e) {
    const el = e.currentTarget;
    const subDwn = el.querySelectorAll('.link-content ul li');
    switch (e.code) {
      case "ArrowDown":
        e.preventDefault();
        el.classList.add('active');
        subDwn[0].querySelector('a').focus();
        break;
      case "Space":
        e.preventDefault();
        el.classList.add('active');
        subDwn[0].querySelector('a').focus();
        break;
      default:
        break;
    }
  }

  handleSubDwnOptionsKeyDown(e) {
    e.stopPropagation();
    const el = e.currentTarget;
    const allOptions = el.closest('ul').querySelectorAll('li');
    let selectedOption = allOptions[0].querySelector('a');
    allOptions.forEach((item, index) => {
      switch (e.code) {
        case "ArrowDown":
          e.preventDefault();
          if (el === item) {
            if (allOptions.length === index + 1) {
              selectedOption = allOptions[0].querySelector('a');
            } else {
              selectedOption = allOptions[index + 1].querySelector('a');
            }
          }
          break;
        case "ArrowUp":
          if (el === item) {
            e.preventDefault();
            if (index === 0) {
              selectedOption = allOptions[allOptions.length - 1].querySelector('a');
            } else {
              selectedOption = allOptions[index - 1].querySelector('a');
            }
          }
          break;
        case "Space":
          e.preventDefault();
          e.currentTarget.closest('.active').classList.remove('active');
          e.currentTarget.closest('.active').focus();
          break;
        case "Tab":
          if (el === item) {
            if (allOptions.length === index + 1) {
              e.currentTarget.closest('.active').classList.remove('active');
            } else {
              e.preventDefault();
              selectedOption = allOptions[index + 1].querySelector('a');
            }
          }
          break;
        default:
          break;
      }
    });
    selectedOption.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
    selectedOption.focus();
  }


  handleHeaderMessage() {
    const alertBanner = this.dom.$alertBanner;
    if (alertBanner) {
      alertBanner.style.height = '50px';
      requestAnimationFrame(() => {
      alertBanner.style.transitionDuration = '0.5s';
      alertBanner.style.transitionProperty = 'all';
      alertBanner.style.height = 0;
      });
    }
  }
}

export default Module;
